import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "@/store/store";
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";
import {Util} from "@/_global/utils";


// CMSで保持する商品の追加情報を格納する


@Module({
    name: "ItemsStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class ItemsStore extends VuexModule {
    // state
    private _apiResponse: CMS.Item[] = [];
    private _itemById: { [itemId: number]: CMS.Item } = {};

    private apiBackup: CMS.Item[] = [];
    private edited: { [itemId: number]: CMS.Item } = {};

    // getter
    get all(): CMS.Item[] {
        return this._apiResponse || [];
    }

    get itemById(): { [p: number]: CMS.Item } {
        return this._itemById || {};
    }

    get dirty(): boolean {
        return Object.keys(this.edited).length > 0;
    }

    @Action
    public async init() {
        const response: CMS.Item[] = (await CmsApiClient.getItems());
        this.refresh(response);
    }

    @Action
    private refresh(response: CMS.Item[]) {
        this.initVals();
        this.setResponse(response);
        for (let i = 0; i < response.length; i++) {
            this.setItemById(response[i]);
        }
    }

    @Mutation
    private initVals(): void {
        this._apiResponse = [];
        this._itemById = {};
        this.edited = {};
    }

    @Mutation
    private setResponse(response: CMS.Item[]) {
        this._apiResponse = response;
        this.apiBackup = Util.deepCopy(this._apiResponse); //復元用にdeep copyでバックアップ
    }

    @Mutation
    private setItemById(item: CMS.Item): void {
        Vue.set(this._itemById, item.item_id, item);
    }

    @Action
    public async create(item: CMS.Item) {
        await CmsApiClient.setItem(item);
        this.init();
    }

    @Mutation
    public localEdit(item: CMS.Item) {
        if (!this._itemById[item.item_id])
            return;

        Vue.set(this._itemById, item.item_id, item);
        Vue.set(this.edited, item.item_id, item);
    }

    @Action
    public async cancelEdit() {
        this.refresh(this.apiBackup);
    }

    @Action
    public async applyEdit() {
        if (!this.dirty)
            return;

        for (const itemId in this.edited) {
            await CmsApiClient.setItem(this.edited[itemId]);
        }
        this.init();
    }
}

export default getModule(ItemsStore);
